// extracted by mini-css-extract-plugin
export default {"ThreeDotsLoader":"ThreeDotsLoader_ThreeDotsLoader__oKCsj"};